// extracted by mini-css-extract-plugin
export default {"mySkeleton":"MySkeleton_mySkeleton__FUiZz","wave":"MySkeleton_wave__eAsrv","text":"MySkeleton_text__rVK8Q"};